export enum STOCK_LEVEL {
    COMPANY = "COMPANY",
    ENTITY = "ENTITY",
    HIERARCHY = "HIERARCHY"
  }
  